import { GE2025_KEYWORD } from "@routes/SingaporeGe/2025/utils/constants";
import {
  SingaporeGe2025Data,
  SingaporeGeData,
} from "@routes/SingaporeGe/utils/types";

/**
 * Helper function to get the ge year.
 *
 * @param {string} route
 * @returns {number}
 */
export const getGeYear = (route: string): number | undefined => {
  if (route.includes(GE2025_KEYWORD)) return 2025;
};

/**
 * Helper function to check if the data is GE 2025 Data
 *
 * @param {SingaporeGeData} data
 * @returns {data is SingaporeGe2025Data}
 */
export const isSingaporeGe2025Data = (
  data: SingaporeGeData
): data is SingaporeGe2025Data => {
  return data.highlights !== undefined && data.year === 2025;
};

/**
 * Helper function to get the ge data based on the ge year. We do this to type the ge data properly.
 */
export const getSingaporeGeData = (data: SingaporeGeData) => {
  if (isSingaporeGe2025Data(data)) {
    return data;
  }
};
